import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "../question-base";

export class PassWordQuestion extends QuestionBase<string> {
  override type = InputType.PASSWORD;
}